export const SCHEDULED_PACKAGES = "scheduledPackages";
export const EXISTING_BATCHES = "existingBatches";
export const DRIVER_USERS = "driverUsers";
export const BATCHED_PACKAGES = "batchedPackages";
export const PREVIOUS_ROUTER_BATCHES = "previousRouterBatches";
